import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'

const About = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={ME} alt="About" />
          </div>
        </div>

        <div className='about__content'>
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small>2+ Years Practice</small>
            </article>
            <article className='about__card'>
              <FiUsers className='about__icon' />
              <h5>Clients</h5>
              <small>0 Clients</small>
            </article>
            <article className='about__card'>
              <VscFolderLibrary className='about__icon' />
              <h5>Projects</h5>
              <small>5+</small>
            </article>

          </div>

          <p>Hello! it's me Rohit Dahal, From Itahari. Currently I m doing Bachelors In Computer Application (BCA) at Koshi St. James College. Well from child age i was excited about laptop, mobile and PC and it turned out that i was much passionate about these stuffs because i was so interested to learn new things like building websites, graphic designing etc. i did diploma in graphic designing after passing SEE and also i completed Web designing after passing high-school and it is going great in this field and i am excited to learn more.
          </p>

          <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>

    </section>

  )
}

export default About